import Misurazioni from "../";

const routes = [
    { name: "MisurazioniList", path: "/misurazioni", component: Misurazioni.MisurazioniList, meta: { title: "Misurazioni" } },
];

export default routes;